module.exports = __webpack_public_path__ + "static/media/w2.674fa41e.svg";